import React from 'react'
import './ModeratorBottomPanel.css'
import trades from "../../images/gameplay_ui/icons/bottom_panel/trades.svg";
import trades_bg from "../../images/gameplay_ui/icons/bottom_panel/trades_bg.svg";
import ButtonWithIcon from "../Utils/ButtonWithIcon";
import {GAME_BUTTONS_NEXT_NAME, DAY_NAMES} from "../../constants/Constants";
import GameButtonWithText from "../InGameUI/GameButtonWithText";

class ModeratorBottomPanel extends React.Component {
    render() {
        let game = this.props.parent.state.game_info;
        if (game == null) return "";

        let start_game = new Date(Date.parse(game.started_at));
        let end_game = new Date(Date.parse(game.ended_at));

        let dayName = (this.props.game_state === 5 ? ` (${DAY_NAMES[this.props.game_day]})` : "");
        let game_state = <div className='moderator-bottom-panel-button'>
            {
                <button className={'main-btn'} onClick={() => {
                        this.props.onPressPlay()
                }}>
                    {(!game.is_started ? "Начать игру" : GAME_BUTTONS_NEXT_NAME[this.props.game_state] + dayName)
                    }</button>
            }

        </div>;
        return <div className='moderator-bottom-panel'>
            {game_state}
            <div className='moderator-bottom-panel-date-title'>
                <b>ДАТА<br/>ПРОВЕДЕНИЯ</b>
            </div>
            <div className='moderator-delimeter-line-big'>

            </div>
            <div className='moderator-bottom-panel-date'>
                <div className='moderator-date-text-small'>ДАТА НАЧАЛА</div>
                <div className='moderator-date-text-big'><b>
                    {`${("0" + start_game.getDate()).slice(-2)}.${("0" + (start_game.getMonth() + 1)).slice(-2)}.${start_game.getFullYear()}`}
                </b></div>
            </div>
            <div className='moderator-delimeter-line-small'>

            </div>
            <div className='moderator-bottom-panel-date'>
                <div className='moderator-date-text-small'>ДАТА ОКОНЧАНИЯ</div>
                <div className='moderator-date-text-big'><b>
                    {`${("0" + end_game.getDate()).slice(-2)}.${("0" + (end_game.getMonth() + 1)).slice(-2)}.${end_game.getFullYear()}`}</b>
                </div>
            </div>
            <div className="moderator-bottom-panel-trades">
                <ButtonWithIcon onClick={() => {this.props.openTrades()}}
                                icon={trades}
                                background={trades_bg}
                                bgColor="#006E8C"
                                bgColorHover="#006E8C"
                                bgColorActive="#006E8C"
                                size={60}
                />
            </div>
            {this.props.canShowStats && <div className="moderator-bottom-panel-stats">
                <GameButtonWithText title={"Статистика"} colorStart={"#FFCC33"} colorEnd={"#F2994A"} width={170} height={40}
                                    fontSize={20} style={{marginLeft: "30px"}} onClick={this.props.openStats}/>
            </div>}
            <GameButtonWithText title={"Смена фазы"} colorStart={"#FFCC33"} colorEnd={"#F2994A"} width={170} height={40}
                                fontSize={20} style={{marginLeft: "30px"}} onClick={this.props.openSaves}/>
        </div>

    }
}

export default ModeratorBottomPanel;
